import {lazy, memo} from 'react'
import {useMeta} from '../../../../hooks/entity/useMeta'
import {useLogged} from '../../../../states/auth'
import {useLoginModal} from '../../../../states/loginModal'
import {useKeepMounted} from '../../../../hooks/useKeepMounted'

const UserLoginPopupNotLoggedAsync = lazy(async () => ({default: (await import('./UserLoginPopupNotLoggedAsync')).UserLoginPopupNotLoggedAsync}))

const UserLoginPopupNotLogged = memo(() => {
  useMeta() // warmup meta fetching
  const loginModal = useLoginModal()
  const isMounted = useKeepMounted(loginModal)

  if (!isMounted) {
    return null
  }

  return <UserLoginPopupNotLoggedAsync/>
})

export const UserLoginPopup = memo(() => {
  const logged = useLogged()

  return logged !== false ? null : <UserLoginPopupNotLogged/>
})
